import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"
import {
  TextChart,
  TextChartMinor,
} from "components/widgets/ScorePage/widgets/TextCharts"
import Unit from "views/atoms/reports/Unit"
import HelpWidgetChartInteractiveMolecule from "views/molecules/interactive/HelpWidgetChartInteractiveMolecule" 
import { convertEmissionValue } from "services/units/valueConversion"
import { round } from "services/units/round"
import { T_CO2E } from "services/units/units"
import ChartWithBadgeWrapperMolecule from "views/molecules/charts/ChartWithBadgeWrapperMolecule"

const TextChartODD13GHGEmissionsMajorDCMolecule = ({ score, trendBadge }) => { 
  const { t } = useTranslation()
  const translationPrefix = "score:score.13."

  const data = score?.odd13_internal_hosting_ghg_emissions_average || {}

  const valueConverted = convertEmissionValue(data?.median_big?.total, T_CO2E)

  const medianBigContent = {
    kpi: round(valueConverted.value, 0),
    kpi_unit: t(`units:units.emission.${valueConverted.unit}`),
    kpi_text: t(`${translationPrefix}chartGHGEmissionsMajorDC.median_big_text`),
    reference: "*" + data?.median_big?.average,
    reference_unit: (
      <Unit
        unit={t(`${translationPrefix}chartGHGEmissionsMajorDC.reference_unit`)}
      />
    ),
    reference_text: t(`${translationPrefix}chartGHGEmissionsMajorDC.subtext`),
  }

  const contentForDisplay = <TextChartMinor content={medianBigContent} />

  const chartContent = (

      <TextChart content={contentForDisplay} />
  )

  return (
    <ChartWithBadgeWrapperMolecule trendBadge={trendBadge} color="auto" >
      {chartContent}
    </ChartWithBadgeWrapperMolecule>
  )
}

TextChartODD13GHGEmissionsMajorDCMolecule.propTypes = {
  score: PropTypes.object,
  trendBadge: PropTypes.object,
}

TextChartODD13GHGEmissionsMajorDCMolecule.defaultProps = {
  trendBadge: null,
}

export default TextChartODD13GHGEmissionsMajorDCMolecule
